import { useTranslation } from 'react-i18next'

import { RowActions } from '../../../../listItem/rowActions/RowActions'

import { useAuth } from '../../../../../contexts/AuthContext'
import { ProfileMetadata } from '../../../../../types/user/userProfile'
import { ActionType } from '../../../../../constants/actionTypes'

export type UserCardActionHandler = (
  user: ProfileMetadata,
  action: ActionType,
  roles?: string[]
) => void

type UserCardActionsProps = {
  user: ProfileMetadata
  onAction: UserCardActionHandler
  actionLoading?: boolean
}

export const UserCardActions = ({
  user,
  onAction,
  actionLoading = false,
}: UserCardActionsProps) => {
  const { t } = useTranslation('users')
  const { authenticatedUserId } = useAuth()
  const locked = user.locked
  const isAuthenticatedUser =
    String(user.userId) === String(authenticatedUserId)

  return (
    <RowActions
      label={t('users.actions.more')}
      disabled={actionLoading}
      items={[
        {
          key: 'view',
          label: t('users.actions.view'),
          icon: 'eye',
          onClick: () => onAction(user, ActionType.VIEW),
        },
        ...(isAuthenticatedUser
          ? []
          : [
              {
                key: 'lock',
                label: t(
                  locked ? 'users.actions.unlock' : 'users.actions.lock'
                ),
                icon: locked ? 'check' : 'lock',
                onClick: () => onAction(user, ActionType.LOCK),
              },
              {
                key: 'reset-password',
                label: t('users.actions.reset-password'),
                icon: 'mail',
                onClick: () => onAction(user, ActionType.RESET_PASSWORD),
              },
              {
                key: 'delete',
                label: t('users.actions.delete'),
                icon: 'trash',
                danger: true,
                onClick: () => onAction(user, ActionType.DELETE),
              },
            ]),
      ]}
    />
  )
}
